<template>
  <div class="operation-panel bg-transparent rounded-2px z-99 w-full h-full pt-10px">
    <div class="flex items-center mb-10px h-32px leading-32px">
      <img src="../../../assets/images/titleIcon.png" alt />
      <div class="text-16px text-[#fff] ml-5px">防腐保温</div>
    </div>
    <div class="detail-wrap w-full overflow-y-auto">
      <div
        class="flex items-center text-[#fff] text-14px font-semibold mb-15px"
        v-for="(item, index) in detailList"
        :key="index"
      >
        <span class="inline-block w-100px text-[#bebebe] text-right">{{ item.label }}</span
        >：
        <span>{{ item.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ThreeDimensionsApi } from '@wiz-api/guang-xi-shi-hua'

const threeDimensionsApi = new ThreeDimensionsApi()

export default {
  components: {},
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      detailList: [],
    }
  },
  watch: {
    'transferProps.code': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getMetarialList()
        }
      },
    },
  },
  computed: {},
  async created() {
    if (this.transferProps.code) {
      this.getMetarialList()
    }
  },
  methods: {
    // 获取详情清单
    getMetarialList() {
      const detailData = {
        diameter: this.transferProps.nominalSize
          ? Number(this.transferProps.nominalSize.replace(/[^0-9.]/gi, ''))
          : null,
        length: this.transferProps.length,
        thickness: this.transferProps.insulationThickness,
      }
      let surfaceArea = null
      let antiCorrosive = null
      let volume = null
      if (detailData.diameter && detailData.length) {
        surfaceArea = Number(
          // eslint-disable-next-line no-restricted-properties
          (Math.PI * detailData.diameter * Math.pow(0.1, 3) * detailData.length).toFixed(4)
        )
        antiCorrosive = surfaceArea
        if (detailData.thickness) {
          volume =
            Math.PI *
            // eslint-disable-next-line no-restricted-properties
            (detailData.thickness * Math.pow(0.1, 3) * 1.033) *
            (detailData.diameter + detailData.thickness * 1.033) *
            // eslint-disable-next-line no-restricted-properties
            Math.pow(0.1, 3) *
            detailData.length
        }
      }
      console.log(detailData, '详情信息', this.transferProps)
      this.detailList = [
        {
          code: 'diameter',
          label: '管径(mm)',
          value: detailData.diameter,
        },
        {
          code: 'length',
          label: '长度(m)',
          value: detailData.length,
        },
        {
          code: 'surfaceArea',
          label: '外表面积(㎡)',
          value: surfaceArea,
        },
        {
          code: 'antiCorrosive',
          label: '防腐面积(㎡)',
          value: antiCorrosive,
        },
        {
          code: 'thickness',
          label: '保温厚度(mm)',
          value: detailData.thickness,
        },
        {
          code: 'volume',
          label: '保温体积(m³)',
          value: volume ? Number(volume.toFixed(5)) : null,
        },
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
.detail-wrap {
  max-height: calc(100% - 40px);
}
</style>
